import React from "react";
import "./commonServices.css";
import Game from "../../Loading/GameLoading";

const GameServices = () => {
  return (
    <div className="it_services">
      <div className="it_left">
        <Game />
      </div>
      <div className="it_right">
        <span className="service-category">Interactive Gaming</span>
        <h2>Immersive 2D & 3D Game Engineering</h2>
        <p>
          We craft breathtaking interactive experiences that captivate players
          across all platforms. Our veteran developers blend cutting-edge
          rendering with optimized performance to bring your creative vision to
          life in Unity and Unreal Engine.
        </p>
        <div className="data_it">
          <p>AAA PC & Console Dev</p>
          <p>Cocos2d-x & Unity Mobile</p>
          <p>Multiplayer Core Logic</p>
          <p>AR/VR Metaverse R&D</p>
          <p>3D Asset Pipeline</p>
          <p>Cross-Platform Porting</p>
        </div>
      </div>
    </div>
  );
};

export default GameServices;
